/**
 * Component Registry for Pala Mesa
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-preferred/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { NeighborhoodMap } from './components/NeighborhoodMap';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  NeighborhoodMap,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
